module.exports = __webpack_public_path__ + "media/islamic.453468ee.mp4";